import { useState, useEffect } from 'react';
import StorageHelper from '../utils/storageHelper';

interface GameInstructionsReturn {
  showInstructions: boolean;
  setShowInstructions: React.Dispatch<React.SetStateAction<boolean>>;
  hasCheckedInstructions: boolean;
}

export const useGameInstructions = (loading: boolean, game: any): GameInstructionsReturn => {
  const [showInstructions, setShowInstructions] = useState(false);
  const [hasCheckedInstructions, setHasCheckedInstructions] = useState(false);

  useEffect(() => {
    if (!hasCheckedInstructions && !loading && game) {
      const hasSeenInstructions = StorageHelper.getItem('famousInitials_hasSeenInstructions');
      if (!hasSeenInstructions) {
        setShowInstructions(true);
      }
      setHasCheckedInstructions(true);
    }
  }, [loading, game, hasCheckedInstructions]);

  return {
    showInstructions,
    setShowInstructions,
    hasCheckedInstructions
  };
};